<template>
  <div>
    <!-- header -->
    <div class="fd-head">
      <h3>企业经济活动国家级虚拟仿真实验教学示范中心</h3>
      <h4>实验室开放预约数据面板</h4>
      <!-- 链接 -->
      <div class="page-fl">
        <router-link :to="'/data2'">
          <div class="fd-weekbutton">
            <span class="fd-week-ico fd-weekfl"></span>
            <span class="fd-weektext">上一页</span>
          </div>
        </router-link>
      </div>
      <div class="page-fr">
        <router-link :to="'/data4'">
          <div class="fd-weekbutton">
            <span class="fd-weektext">下一页</span>
            <span class="fd-week-ico fd-weekfr"></span>
          </div>
        </router-link>
      </div>
    </div>
    <!-- fl-->
    <div class="fd-fl" style="width: 38%">
      <!-- 折线图 -->
      <div class="demo-w demo-box mar-bot">
        <div class="title">
          <span class="txt fd-tit">实验室年度开放数据</span>
          <div class="line"></div>
        </div>
        <div class="content">
          <div class="fd-data fd-data-big">
            <ul>
              <li>
                <span class="fd-data-ico fd-data-time"></span>
                <span class="fd-data-name" v-if="statModel.years.length > 0"
                  >累计历史开放时数({{ statModel.years[0].year }}年至今)</span
                >
                <span class="fd-data-num">{{ statModel.totalHours }}</span>
              </li>
              <li>
                <span class="fd-data-ico fd-data-people"></span>
                <span class="fd-data-name" v-if="statModel.years.length > 0"
                  >累计历史使用人数({{ statModel.years[0].year }}年至今)</span
                >
                <span class="fd-data-num">{{ statModel.totalNumber }}</span>
              </li>
            </ul>
          </div>
          <div id="fd-pie1" style="width: 100%; height: 300px"></div>
        </div>
      </div>
      <!-- 柱状图 -->
      <div class="demo-w demo-box mar-bot">
        <div class="title">
          <span class="txt fd-tit">实验室累计开放时数</span>
          <div class="line"></div>
        </div>
        <div class="content">
          <div id="fd-pie2" style="width: 100%; height: 282px"></div>
        </div>
      </div>
    </div>
    <!-- fr -->
    <div class="fd-fr" style="width: 59%; margin-right: 20px">
      <div class="demo-w demo-box mar-bot">
        <div class="title">
          <span class="txt fd-tit">实验室开放活动列表</span>
          <div class="line">
            <div class="fa-radio">
              <label @click="ClickStatus(0)">
                <input
                  name="State"
                  type="radio"
                  class="p-radio"
                  checked="checked"
                />
                <i>全部</i>
              </label>
              <label @click="ClickStatus(1)">
                >
                <input name="State" type="radio" class="p-radio" />
                <i>预约待审核</i>
              </label>
              <label @click="ClickStatus(2)">
                >
                <input name="State" type="radio" class="p-radio" />
                <i>审核通过未完成</i>
              </label>
              <label @click="ClickStatus(3)">
                >
                <input name="State" type="radio" class="p-radio" />
                <i>活动已完成</i>
              </label>
            </div>
          </div>
        </div>
        <div class="content">
          <div class="fd-data fd-data-small">
            <ul>
              <li>
                <span class="fd-data-ico fd-data-years"></span>
                <span class="fd-data-name">本年度预约次数</span>
                <span class="fd-data-num">{{ statModel.thisYearCount }}</span>
              </li>
              <li>
                <span class="fd-data-ico fd-data-month"></span>
                <span class="fd-data-name">本月预约次数</span>
                <span class="fd-data-num">{{ statModel.thisMonthCount }}</span>
              </li>
              <li>
                <span class="fd-data-ico fd-data-day"></span>
                <span class="fd-data-name">本日预约次数</span>
                <span class="fd-data-num">{{ statModel.todayCount }}</span>
              </li>
            </ul>
          </div>
          <!-- 活动 -->
          <div class="fd-act fd-act-head" style="font-size: 16px">
            <ul>
              <li>
                <span class="fd-act-time">活动时间</span>
                <span class="fd-act-room">活动地点</span>
                <span class="fd-act-state">活动状态</span>
                <span class="fd-act-theme">活动主题</span>
              </li>
            </ul>
          </div>
          <!-- 内容 -->
          <div class="txtScroll-top">
            <div class="hd">
              <a class="next"></a>
              <!-- <ul>
                <li v-for="index in 3" :key="index">{{ index }}</li>
              </ul> -->
              <a class="prev"></a>
            </div>
            <div class="bd">
              <!-- li -->
              <div class="fd-act">
                <ul>
                  <li v-for="(item, index) in activityList" :key="index">
                    <span class="fd-act-time">{{
                      moment(item.date).format("YYYY-MM-DD")
                    }}</span>
                    <span class="fd-act-room ell">{{ item.add }}</span>
                    <span
                      class="fd-act-state red"
                      v-if="item.status == '预约待审核'"
                      >{{ item.status }}</span
                    >
                    <span
                      class="fd-act-state orange"
                      v-if="item.status == '审核通过未完成'"
                      >{{ item.status }}</span
                    >
                    <span
                      class="fd-act-state green"
                      v-if="item.status == '活动已完成'"
                      >{{ item.status }}</span
                    >
                    <span class="fd-act-theme ell" style="text-align: center">{{
                      item.title
                    }}</span>
                  </li>
                </ul>
              </div>
              <!-- end -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
  </div>
</template>

<script>
import $ from '../../static/js/jquery.min.js'
import jQuery from '../../static/js/jquery.SuperSlide.2.1.3'

import echarts from 'echarts'
import {
  getApi
} from '../../static/js/api.js'
import moment from 'moment'
export default {
  data () {
    return {
      statModel: {
        totalHours: 0,
        totalNumber: 0,
        years: [],
        laboratorys: [],
        thisYearCount: 0,
        thisMonthCount: 0,
        todayCount: 0
      },
      status: 0,
      activityList: []
    }
  },
  methods: {
    moment,
    ClickStatus (type) {
      this.status = type
      this.loadActivityList()
    },
    loadActivityList () {
      let that = this
      getApi('/bi/GetActivityList', {
        status: that.status
      }, 'Post').then(res => {
        if (res.IsSuccess) {
          that.activityList = res.SuccessData
          setTimeout(() => {
            jQuery(".txtScroll-top").slide({
              titCell: ".hd ul",
              mainCell: ".bd ul",
              autoPage: true,
              effect: "top",
              vis: 11,
              scroll: 11,
              delayTime: 700,
              pnLoop: false,
              mouseOverStop: false,
              autoPage: "<li></li>"
            });
          }, 800)
        }
      })
    }
  },
  mounted () {
    let that = this

    that.loadActivityList()
    getApi('/bi/GetActivityStat').then(res => {
      if (res.IsSuccess) {
        that.statModel = res.SuccessData
      }
    }).finally(() => {
      // 实验室年度数据
      var myChartPie1 = echarts.init(document.getElementById('fd-pie1'));
      var option1 = {
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          right: '10%'
        },
        legend: {
          data: ['时数', '人数'],
          textStyle: {
            color: '#aaecff'
          }
        },
        xAxis: [{
          type: 'category',
          axisTick: {
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: '#aaecff'
            }
          },
          data: that.statModel.years.map(v => v.year)
        }],
        yAxis: [{
          type: 'value',
          name: '时数',
          min: 0,
          position: 'right',
          axisLine: {
            lineStyle: {
              color: '#aaecff'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#1b3676'
            }
          },
          axisLabel: {
            formatter: '{value}'
          }
        },
        {
          type: 'value',
          name: '人数',
          min: 0,
          position: 'left',
          axisLine: {
            lineStyle: {
              color: '#aaecff'
            }
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            formatter: '{value}'
          }
        }
        ],
        series: [{
          name: '时数',
          type: 'line',
          symbol: 'circle',
          itemStyle: {
            color: '#ff1e6d'

          },
          data: that.statModel.years.map(v => v.hours)
        },
        {
          name: '人数',
          type: 'line',
          symbol: 'circle',
          yAxisIndex: 1,
          itemStyle: {
            color: '#c79232'

          },
          data: that.statModel.years.map(v => v.peopleNum)
        }
        ]
      };
      myChartPie1.setOption(option1, true);

      // 实验室累计时数
      var myChartPie2 = echarts.init(document.getElementById('fd-pie2'));
      var option2 = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          right: '3%',
          bottom: '10%',
          left: '6%'
        },
        xAxis: [{
          type: 'category',
          axisTick: {
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: '#aaecff'
            }
          },
          data: that.statModel.laboratorys.map(v => v.roomCode)
        }],
        yAxis: [{
          type: 'value',
          name: '时数',
          min: 0,
          position: 'left',
          axisLine: {
            lineStyle: {
              color: '#aaecff'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#1b3676'
            }
          },
          axisLabel: {
            formatter: '{value}'
          }
        },],
        series: [{
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: 'top',
                textStyle: {
                  color: '#fff',
                  fontSize: 12
                }
              },
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [{
                  offset: 0.5,
                  color: '#0084ff'
                },
                {
                  offset: 1,
                  color: '#02daff'
                }
                ]
              )
            }
          },
          barWidth: '50%',
          data: that.statModel.laboratorys.map(v => v.hours),
          type: 'bar'
        }]
      };
      myChartPie2.setOption(option2, true);
    })
  }
}
</script>

<style>
</style>
